/* loaded by smart-asset */
export default require("./assets/pick-cart.i.svg")